import { useContext, useEffect, useState } from "react";

import Loading from "../../../components/basics/Loading";
import HeaderModule from "../../../components/header/HeaderModule";
import {
  GerenciamentoContratoContext,
  GerenciamentoContratoContextProvider,
} from "./contexts/GerenciamentoContratoContext";
import { GerenciamentoContratoFilterContext } from "./contexts/GerenciamentoContratoFilterContext";
import { ConfigurationContext } from "./contexts/ConfigurationContext";
import { QueryParamsContext } from "../../../context/QueryParamsContext";
import { useHistory } from "react-router-dom";
import useGerenciamentoContratoListagemController from "./controllers/GerenciamentoContratoListagemController";
import SpeedDialErp from "./../../../components/speeddial/SpeedDialErp";
import {
  EditOutlined,
  VisibilityOutlined,
  CancelOutlined,
  Add,
  Search,
  MonetizationOnOutlined,
  AssignmentLateOutlined,
  LocalPrintshopOutlined,
  EmailOutlined,
  EventBusy,
  Check,
  Clear,
  UndoOutlined,
} from "@material-ui/icons";
import MaskService from "./../../../utils/mask/maskService";
import { Container, Grid, Tooltip } from "@material-ui/core";
import { Margin } from "./../../financeiro/nfe/styles/Emissao";
import SearchSelect from "./../../../components/inputs/SearchSelect";
import SelectErp from "../../../components/basics/SelectErp";
import TextFieldErp from "./../../../components/basics/TextFieldErp";
import TableDefault from "./../../../components/grid/TableDefault";
import Btn from "../../../components/buttons/Btn";
import { ModalLog } from "./../../../patterns/modals/modallog/ModalLog";
import { ModalCancelamentoContrato } from "./children/ModalCancelamentoContrato";
import { ModalEdicaoFinanceiro } from "./children/ModalEdicaoFinanceiro";
import useGerenciamentoContratoController from "./controllers/GerenciamentoContratoController";
import { GlobalVariables } from "../../../GlobalVariables";
import ModalEmailContract from "./children/ModalEmailContract";
import moment from "moment";
import { ModalReativarContrato } from "./children/ModalReativarContrato";

const View = () => {
  const {
    numeroContrato,
    setNumeroContrato,
    initialDate,
    setInitialDate,
    finalDate,
    setFinalDate,
    client,
    setClient,
    typeContract,
    setTypeContract,
    typeStatus,
    setTypeStatus,
    typePorDataDe,
    setTypePorDataDe,
    disabledButtonSearch,
    itensTable,
    setItensTable,
    mainLoading,
    setMainLoading,
    openEmail,
    setOpenEmail,
    listTypeContract,
    idTypeContract,
    setIdTypeContract,
    modalReativacaoContratoOpen,
    setModalReativacaoContratoOpen,
  } = useContext(GerenciamentoContratoContext);

  const { configuration } = useContext(ConfigurationContext);

  const { listBillingRules } = useContext(GerenciamentoContratoFilterContext);

  const { queryParams } = useContext(QueryParamsContext);

  const { push } = useHistory();

  const {
    handleSearchContract,
    initHandleIntesTable,
    openLog,
    handleOpenModalCancel,
    handleOpenModalEdicao,
  } = useGerenciamentoContratoListagemController();
  const { handleSuspensionContract, handleDownloadPdf } =
    useGerenciamentoContratoController();

  const [modalLogOpen, setModalLogOpen] = useState(false);
  const [contentLog, setContentLog] = useState(null);

  const [modalCancelOpen, setModalCancelOpen] = useState(false);
  const [idModalCancel, setIdModalCancel] = useState(null);

  const [modalEdicaoOpen, setModalEdicaoOpen] = useState(false);
  const [contractDataEditFinancial, setContractDataEditFinancial] =
    useState(null);

  const [modeloliente, setModeloCliente] = useState([]);

  const [selectedContract, setSelectedContract] = useState([]);

  const enableReadjustment = !!(
    !!selectedContract.length &&
    !selectedContract.find(
      (contract) => contract.modalidade === "A" || contract.status !== "A"
    )
  );

  useEffect(() => {
    if (!queryParams.empresa_cnpj || !queryParams.empresa_id) return;

    initHandleIntesTable();
  }, [initHandleIntesTable, queryParams.empresa_cnpj, queryParams.empresa_id]);

  const [listTypeModal] = useState([
    { label: "Todos", value: "all" },
    { label: "Recorrente", value: GlobalVariables.contract.modality.recurring },
    { label: "Avulso", value: GlobalVariables.contract.modality.separate },
  ]);

  const [listTypeStatus] = useState([
    { label: "Todos", value: "all" },
    { label: "Ativo", value: "A" },
    { label: "Cancelado", value: "C" },
    { label: "Suspenso", value: "S" },
  ]);

  const [listTypePorDataDe] = useState([
    { label: "Emissão", value: "emissao" },
    { label: "Reajuste", value: "reajuste" },
    { label: "Cancelamento", value: "cancelamento" },
    { label: "Suspensão", value: "suspensao" },
  ]);

  const columns = [
    {
      disabled: true,
      id: "acoes",
      label: "Ações",
      description: "Ações",
      align: "center",
      format: (item) => (
        <SpeedDialErp
          actions={[
            {
              icon: <VisibilityOutlined />,
              name: "Visualizar alterações",
              action: () => openLog(item, setModalLogOpen, setContentLog),
            },
            {
              icon: <EditOutlined />,
              name: "Abrir Contrato",
              action: () => push("cadastro", item),
            },
            {
              icon: <MonetizationOnOutlined />,
              name: "Editar financeiro",
              action: () =>
                handleOpenModalEdicao(
                  {
                    id: item.id,
                    numero: item.numero,
                    nfse: item.flag_emitir_nfse,
                  },
                  setModalEdicaoOpen,
                  setContractDataEditFinancial
                ),
              disabled:
                item.modalidade === GlobalVariables.contract.modality.separate,
            },
            {
              icon: <CancelOutlined />,
              name: "Cancelar Contrato",
              action: () => {
                handleOpenModalCancel(
                  item.id,
                  setModalCancelOpen,
                  setIdModalCancel
                );
              },
              disabled: item.status === GlobalVariables.clientContract.canceled,
            },
            {
              icon: <UndoOutlined />,
              name: "Reativar Contrato",
              action: () => {
                setModalReativacaoContratoOpen(true);
                setIdModalCancel(item.id);
              },
              disabled: item.status !== GlobalVariables.clientContract.canceled,
            },

            {
              icon: <AssignmentLateOutlined />,
              name:
                item.status === GlobalVariables.clientContract.active
                  ? "Suspender Contrato"
                  : "Reativar Contrato",
              action: () => {
                handleSuspensionContract(
                  item.id,
                  item.status,
                  item.datavencimento1
                );
              },
              disabled: item.status === GlobalVariables.clientContract.canceled,
            },
            {
              icon: <LocalPrintshopOutlined />,
              name: "Imprimir Contrato",
              action: () => {
                handleDownloadPdf(item.id);
              },
            },
            {
              icon: <EmailOutlined />,
              name: "Enviar Contrato por E-mail",
              action: () => {
                setModeloCliente(item);
                setOpenEmail(true);
              },
            },
          ]}
        />
      ),
    },
    {
      id: "numero",
      label: "Nr. Contrato",
      description: "Número do Contrato",
    },
    {
      id: "dataemissao",
      label: "Emissão",
      description: "Data de Emissão",
      format: (value) =>
        value.dataemissao
          ? moment(value.dataemissao, "YYYY-MM-DD").format("DD/MM/YYYY")
          : "",
    },
    {
      id: "cliente",
      label: "Cliente",
      description: "Cliente",
      style: { minWidth: 200 },
    },
    {
      id: "total",
      label: "Valor",
      description: "Valor do Contrato",
      align: "right",
      style: { minWidth: 100 },
      format: (value) =>
        `R$ ${MaskService.toMask(
          "decimal",
          parseFloat(value.total).toFixed(2)
        )}`,
    },
    {
      id: "proposta",
      label: "Proposta",
      description: "Proposta",
    },
    {
      id: "modalidade",
      label: "Mod",
      description: "Modalidade",
      align: "center",
    },
    {
      id: "tipocontrato",
      label: "Tipo Serviço",
      description: "Tipo de Serviço",
      style: { minWidth: 150 },
      format: (value) => {
        return value?.tipocontrato?.descricao;
      },
    },
    {
      id: "vigencia_renovacao",
      label: "Vigência",
      description: "Vigência",
    },
    {
      id: "status",
      label: "Status",
      description: "Status",
      align: "center",
      tooltip: (value) => {
        if (value.datacancelamento)
          return (
            "Contrato cancelado em " +
            moment(value.datacancelamento, "YYYY-MM-DD").format("DD/MM/YYYY")
          );

        if (value.datasuspensao)
          return (
            "Contrato suspenso em " +
            moment(value.datasuspensao, "YYYY-MM-DD").format("DD/MM/YYYY")
          );

        return "Contrato ativo";
      },
    },
    {
      id: "dataultimoreajuste",
      label: "Último Reajuste",
      description: "Data do Último Reajuste",
      format: (value) =>
        value.dataultimoreajuste
          ? moment(value.dataultimoreajuste, "YYYY-MM-DD").format("DD/MM/YYYY")
          : "-",
    },
    {
      id: "regua_cobranca_id",
      label: "Régua",
      description: "Régua de Cobrança",
      format: (value) =>
        value?.regua_cobranca_id ? (
          <Check style={{ color: "green" }} />
        ) : (
          <Clear style={{ color: "red" }} />
        ),
      tooltip: (value) => {
        const rule = listBillingRules.find(
          (rule) => rule.value === value.regua_cobranca_id
        );
        return rule ? rule.label : "";
      },
    },
  ];

  const handleClear = () => {
    setInitialDate(null);
    setFinalDate(null);
  };

  const handleOpenReadjustmentContract = () => {
    const selectedIds = JSON.stringify(
      selectedContract.map((contract) => contract.id)
    );

    const oldPath = window.location.href;
    window.location.href = `${process.env.REACT_APP_URL_REACT_V2}/view/faturamento/reajustecontrato/${selectedIds}?empresa_cnpj=${queryParams.empresa_cnpj}&usuario_id=${queryParams.usuario_id}&usuario_nome=${queryParams.usuario_nome}&usuario_email=${queryParams.usuario_email}&empresa_id=${queryParams.empresa_id}&gfAccessToken=${queryParams.gfAccessToken}&oldPath=${oldPath}`;
    return;
  };

  return (
    <>
      <Loading open={mainLoading} />
      <HeaderModule
        title="GERENCIAMENTO DE CONTRATO DE SERVIÇO"
        videoId={GlobalVariables.screenVideosIds.gerenciamentoContratoServico}
      />

      {modalLogOpen && (
        <ModalLog
          open={modalLogOpen}
          content={contentLog}
          setContent={setContentLog}
          setOpen={setModalLogOpen}
          view="contracts"
        />
      )}

      {modalCancelOpen && (
        <ModalCancelamentoContrato
          open={modalCancelOpen}
          contractId={idModalCancel}
          setOpen={setModalCancelOpen}
          setItensTable={setItensTable}
        />
      )}

      {modalReativacaoContratoOpen && (
        <ModalReativarContrato
          open={modalReativacaoContratoOpen}
          setOpen={setModalReativacaoContratoOpen}
          labelModal="REATIVAR CONTRATO"
          contractId={idModalCancel || null}
          refreshFunction={handleSearchContract}
        />
      )}

      {modalEdicaoOpen && (
        <ModalEdicaoFinanceiro
          open={modalEdicaoOpen}
          contractData={contractDataEditFinancial}
          setOpen={setModalEdicaoOpen}
          makeRequestAgain={handleSearchContract}
          setLoading={setMainLoading}
        />
      )}

      {openEmail && (
        <ModalEmailContract
          modalOpen={openEmail}
          setModalOpen={setOpenEmail}
          modelo={modeloliente}
          setMainLoading={setMainLoading}
        />
      )}

      <Margin top={80}>
        <Container maxWidth="xl">
          <Grid container spacing={2} style={{ marginBottom: 10 }}>
            <Grid item xs={6}>
              <SearchSelect
                getOptionLabel={(option) =>
                  `${option.cpfcnpj} - ${option.razao}`
                }
                label="Clientes"
                setValue={setClient}
                route="prouser/clientes/v1"
                filter="razao,apelido,id"
                filterTranslate="cpfcnpj"
                error={false}
                value={client}
                variant="standard"
                where={{ ativo: "S" }}
              />
            </Grid>

            <Grid item xs={2}>
              <SelectErp
                error={false}
                loading={false}
                label="Status"
                value={typeStatus}
                setValue={setTypeStatus}
                optionsList={listTypeStatus}
                descriptionField="label"
                variant="standard"
              />
            </Grid>

            <Grid item xs={2}>
              <SelectErp
                error={false}
                loading={false}
                label="Modalidade"
                value={typeContract}
                setValue={setTypeContract}
                optionsList={listTypeModal}
                descriptionField="label"
                variant="standard"
              />
            </Grid>

            <Grid item xs={2}>
              <SelectErp
                error={false}
                loading={false}
                label="Tipo de Serviços"
                value={idTypeContract}
                setValue={setIdTypeContract}
                optionsList={listTypeContract}
                descriptionField="descricao"
                variant="standard"
              />
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={1}>
              <TextFieldErp
                value={numeroContrato}
                setValue={setNumeroContrato}
                label="Nr. Contrato"
                variant="standard"
                size="small"
                maxLength={4}
              />
            </Grid>

            <Grid item xs={2}>
              <TextFieldErp
                label="Data Inicial"
                variant="standard"
                type="date"
                size="small"
                setValue={setInitialDate}
                value={initialDate}
              />
            </Grid>

            <Grid item xs={1} container justifyContent="center">
              <Tooltip title="Limpar Datas">
                <Btn
                  onClick={() => handleClear()}
                  startIcon={<EventBusy />}
                  hovercolor="orange"
                />
              </Tooltip>
            </Grid>

            <Grid item xs={2}>
              <TextFieldErp
                label="Data Final"
                variant="standard"
                type="date"
                size="small"
                setValue={setFinalDate}
                value={finalDate}
              />
            </Grid>

            <Grid item xs={2}>
              <SelectErp
                error={false}
                loading={false}
                label="Data de"
                value={typePorDataDe}
                setValue={setTypePorDataDe}
                optionsList={listTypePorDataDe}
                descriptionField="label"
                variant="standard"
              />
            </Grid>

            <Grid
              item
              xs={4}
              container
              justifyContent="space-around"
              style={{ gap: "10" }}
            >
              <Grid item xs={3}>
                <Tooltip title="Buscar">
                  <Btn
                    onClick={() => {
                      setSelectedContract([]);
                      handleSearchContract();
                    }}
                    startIcon={<Search />}
                    disabled={disabledButtonSearch}
                    bgcolor="primary"
                    hovercolor="orange"
                    fullWidth
                  />
                </Tooltip>
              </Grid>
              <Grid item xs={3}>
                <Tooltip title="Reajustar contrato(s)">
                  <Btn
                    label="Reajuste"
                    bgcolor="primary"
                    hovercolor="orange"
                    fullWidth
                    disabled={!enableReadjustment}
                    onClick={handleOpenReadjustmentContract}
                  />
                </Tooltip>
              </Grid>
              <Grid item xs={3}>
                <Tooltip title="Novo Contrato">
                  <Btn
                    bgcolor="primary"
                    fullWidth
                    hovercolor="orange"
                    onClick={() => {
                      push("cadastro");
                    }}
                    startIcon={<Add />}
                  />
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
          <Margin top={40}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TableDefault
                  tableTitle=""
                  columns={columns}
                  values={itensTable}
                  smallFont
                  minHeight="350px"
                  sortBy="numero"
                  orderSort="desc"
                  selectable
                  selected={selectedContract}
                  setSelected={setSelectedContract}
                />
              </Grid>
            </Grid>
          </Margin>
        </Container>
      </Margin>
    </>
  );
};

const GerenciamentoContratoListagem = (props) => (
  <GerenciamentoContratoContextProvider>
    <View {...props}></View>
  </GerenciamentoContratoContextProvider>
);

export default GerenciamentoContratoListagem;
